/*
 * @Author: renming-lj 2982488597@qq.com
 * @Date: 2024-05-13 17:47:12
 * @LastEditors: renming-lj 2982488597@qq.com
 * @LastEditTime: 2024-06-12 10:20:51
 * @FilePath: \program_admin\src\http\api.js
 * @Description: api
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
 */
import request from './request';

// 用户登录
export function login(data) {
  return request({
    url: '/user/login',
    method: 'post',
    data
  })
}

// 用户注册
export function register(data) {
  return request({
    url: '/user/register',
    method: 'post',
    data
  })
}

// 忘记密码
export function edit(data) {
  return request({
    url: '/user/edit',
    method: 'post',
    data
  })
}

// 获取用户信息
export function userInfo(data) {
  return request({
    url: '/user/userInfo',
    method: 'post',
    data
  })
}

// 获取验证码
export function getCodes(data) {
  return request({
    url: '/user/code',
    method: 'post',
    data
  })
}

// 修改基本资料
export function userEdit(data) {
  return request({
    url: '/user/userEdit',
    method: 'post',
    data
  })
}

// 上传头像
export function uploadUserImg(data) {
  return request({
    url: '/user/uploadUserImg',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data
  })
}

// 上传图片
export function uploadImg(data) {
  return request({
    url: '/uploadImg',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data
  })
}

// 新增、编辑用户
export function editUser(data) {
  return request({
    url: '/user/editUser',
    method: 'post',
    data
  })
}

// 禁用用户
export function userForbidden(data) {
  return request({
    url: '/user/userForbidden',
    method: 'post',
    data
  })
}

// 删除用户
export function deleteUser(data) {
  return request({
    url: '/user/deleteUser',
    method: 'delete',
    data
  })
}

// 查询数据总量
export function getTotal(data) {
  return request({
    url: '/getTotal',
    method: 'post',
    data
  })
}

// 下载 Excel
export function getDownloadUser(data) {
  return request({
    url: '/user/downloadUser',
    method: 'post',
    data
  })
}

// 下载 Excel 全部
export function getAllDownloadUser(data) {
  return request({
    url: '/user/allDownloadUser',
    method: 'post',
    data
  })
}

// 查询成语列表
export function getIdiom(data) {
  return request({
    url: '/getIdiom',
    method: 'post',
    data
  })
}

// 新增、编辑成语
export function editIdiom(data) {
  return request({
    url: '/editIdiom',
    method: 'post',
    data
  })
}

// 删除成语
export function deleteIdiom(data) {
  return request({
    url: '/deleteIdiom',
    method: 'delete',
    data
  })
}

// 查询歇后语列表
export function getSaying(data) {
  return request({
    url: '/getSaying',
    method: 'post',
    data
  })
}

// 新增、编辑歇后语
export function editSaying(data) {
  return request({
    url: '/editSaying',
    method: 'post',
    data
  })
}

// 删除歇后语
export function deleteSaying(data) {
  return request({
    url: '/deleteSaying',
    method: 'delete',
    data
  })
}

// 查询反馈列表
export function getFeedback(data) {
  return request({
    url: '/getFeedback',
    method: 'post',
    data
  })
}

// 删除反馈
export function deleteFeedback(data) {
  return request({
    url: '/deleteFeedback',
    method: 'delete',
    data
  })
}

// 修改成语热搜
export function setIdiomTop(data) {
  return request({
    url: '/setIdiomTop',
    method: 'post',
    data
  })
}

// 修改歇后语热搜
export function setSayingTop(data) {
  return request({
    url: '/setSayingTop',
    method: 'post',
    data
  })
}

// 获取图片验证码
export function getCodeImg(data) {
  return request({
    url: '/user/getCode',
    method: 'post',
    data
  })
}
